// import { SigningHelper } from './signing.helper';
import { HttpService } from '../http';
import { FalconContext } from './falcon-context';

export class ApplicationContextService {
  /**
   * 获取应用上下文
   *
   * @returns
   * @memberof ApplicationContextService
   */
  static getContext(
    options?: { Currency: string; LanguageCode: string },
    contextHandler?: (ctx: FalconContext.AppContextInfo) => void
  ) {
    return HttpService.get<FalconContext.AppContextInfo>(
      '/Config/AppContext/Get',
      options
      // {
      //   cache: true,
      //   ttl: 10 * 60,
      // }
    ).then((ctx) => {
      ctx.__responseTime__ = new Date();
      if (contextHandler) {
        contextHandler(ctx);
      }
      return ctx;
    });
  }

  static establishSecureTunnel(
    options: FalconContext.SecurityContextEstablishOption
  ) {
    return HttpService.post<FalconContext.SecurityContextEstablishResult>(
      '/Config/SecureContext/Establish',
      options
    ).then((result) => {
      const compactSize = (result.ml_G.length - 1) / 5;
      if (compactSize > 1.5) { // 如果分组太多则进行合并，以减少请求数量
        const next = [[...result.ml_G[0]]];
        const mergeStep = Math.ceil(compactSize);
        for (let i = 1; i < result.ml_G.length;) {
          const target = [...result.ml_G[i]];
          let j = 1;
          for (; j < mergeStep; j++) {
            const current = result.ml_G[i + j];
            if (current) {
              target.push(...current);
            }
          }
          i += j;
          next.push(target);
        }
        result.ml_G = next;
      }
      return result;
    });
  }
}
